module.exports = __webpack_public_path__ + "img/icon1.d4d9c1fd.png";